// extracted by mini-css-extract-plugin
export default {"wrap":"consultationsUserSubordinationArchive_wrap__7ImE5"};